import { Controller } from "@hotwired/stimulus"

/**
 * Stimulus controller for the catalog change review diff viewer.
 * Provides interactive expand/collapse for change details.
 */
export default class extends Controller {
  static targets = ["detail"]

  toggle(event) {
    const detail = event.currentTarget.closest(
      "[data-diff-viewer-target='detail']",
    )
    if (detail) {
      detail.classList.toggle("hidden")
    }
  }
}
